import React, {useEffect, useState} from 'react';
import InfoService from '../components/InfoService';
import { useLocation } from "react-router-dom";
import ROUTERS from "../../../commons/constans/router";
import API, {ROUTES} from "../../../commons/api/api";

const InformationServiceContainer = () => {
  const location = useLocation();

  const [informationData, setInformationData] = useState([])
  const [typeInformation, setTypeInformation] = useState('company_info')
  const [title, setTitle] = useState('')
  const [loadingData, setLoadingData] = useState(true)



  const fetchData = async (param = '?type=company_info') =>{
    try {
      const {data: response} = await API.get(ROUTES.API_INFORMATION_SERVICE+param+'&limit=1');
      setInformationData(response?.data);
      setLoadingData(false)

    } catch (error) {
      console.error(error.message);
      setLoadingData(false)
    }
  }

  useEffect(() => {
    let type= 'company_info'
    if(location?.pathname && location?.pathname == ROUTERS.INFORMATION_SERVICE_TERM){
      setTypeInformation('term')
      type = 'term'
      setTitle('이용약관')
    }else if(location?.pathname && location?.pathname == ROUTERS.INFORMATION_SERVICE_POLICY){
      setTypeInformation('policy')
      type = 'policy'
      setTitle('개인정보 처리방침')
    }else {
      setTypeInformation('company_info')
      setTitle('사업자정보')
    }
    type = '?type=' + type
    fetchData(type);
  }, []);


  return <InfoService informationData={informationData} loadingData={loadingData} title={title} />;

};

export default InformationServiceContainer;
